export const config = {
  adminGoogleClientId: '1023176163489-4cdm1ubc5980gdgbm938h3r5brh6m07i.apps.googleusercontent.com',
  apiGoogleClientId: '1023176163489-4cdm1ubc5980gdgbm938h3r5brh6m07i.apps.googleusercontent.com',
};
